function SearchResultText(moduleEle) {
  var module = this;
  module.moduleEle = moduleEle;

  module.onServerSuccess = function (eventArgs) {
    var resultText = module.moduleEle.data('resultText');
    //console.log('SearchResultText.onServerSuccess()', eventArgs);
    if (eventArgs.response.data.Parameters.Q) {
      let totalNumberOfResults = 0;
      if(!isNaN(eventArgs.response.data.TotalNumberOfItems)) {
        totalNumberOfResults = totalNumberOfResults + eventArgs.response.data.TotalNumberOfItems;
      }
      if (!isNaN(eventArgs.response.data.TotalNumberOfEmployees)) {
        totalNumberOfResults = totalNumberOfResults + eventArgs.response.data.TotalNumberOfEmployees;
      }
      resultText = resultText.format(eventArgs.response.data.Parameters.Q, totalNumberOfResults );
      module.moduleEle.text(resultText);
      module.moduleEle.removeClass('hidden');
    } else {
      module.moduleEle.addClass('hidden');
    }
  }
}

instant.list.settings.moduleClasses['SearchResultText'] = SearchResultText;